export default __webpack_public_path__ + "static/media/Kerala_Hover.2a55c57a.svg";